export function getResults(state) {
  return state.searched
}

export function getResultUser(state) {
  return state.searched[0]
}

export function getResultPost(state) {
  return state.searched[1]
}

export function getResultMenu(state) {
  return state.searched[2]
}

export function getResultBenefit(state) {
  return state.searched[3]
}